import { Button, DialogContent, DialogTitle, Typography } from "@material-ui/core"
import Dialog from "@material-ui/core/Dialog"
import { observable } from "mobx"
import { observer } from "mobx-react"
import * as React from "react"
import { browserVersion, isChrome, isIOS, isMobile, isTablet, osVersion } from "react-device-detect"
import { appTheme, spacing } from "./StyleUtils"

@observer
export class TechCheck extends React.Component {
    @observable
    isBadBrowserOpen = false

    @observable
    badBrowserMessage: string

    checkBrowser = () => {
        if (isMobile && !(isTablet && isIOS && parseFloat(osVersion) >= 13)) {  // Do not support mobile except for iOS tablets with iOS 13+
            this.badBrowserMessage = "Mobile only supported with iPad on iOS 13 or greater"
            this.isBadBrowserOpen = true
        } else if (window.innerWidth < 800 || window.innerHeight < 600) {
            this.badBrowserMessage = "Browser size too small"
            this.isBadBrowserOpen = true
        } else if (!isChrome || Number(browserVersion) < 72) {
            this.badBrowserMessage = "Unsupported Browser"
            this.isBadBrowserOpen = true
        }
    }

    componentDidMount(): void {
        this.checkBrowser()
    }

    render() {
        return (
            <Dialog open={this.isBadBrowserOpen} maxWidth={"sm"} PaperProps={{style: {textAlign: "center", padding: spacing(3)}}}>
                <DialogTitle disableTypography={true}><Typography variant={"h3"}>{this.badBrowserMessage}</Typography></DialogTitle>
                <DialogContent>
                    <Typography>
                        Clickcity was not tested with your current browser. At this time, Click City only officially supports the latest
                        <b> Chrome on mac or windows, or Chrome on iPad with at least iOS 13</b> with a minimum screen size of <b>800x600</b>.
                    </Typography>
                    <Typography variant={"h4"} style={{margin: spacing(3)}}>Proceed at your own risk!</Typography>
                    <div style={{display: "flex", justifyContent: "space-evenly"}}>
                        <Button variant={"contained"} color={"primary"} href={"https://www.google.com/chrome/"}>
                            Download Google Chrome
                        </Button>
                        <Button variant={"contained"} style={{backgroundColor: appTheme.palette.error.main}} onClick={() => this.isBadBrowserOpen = false}>
                            Proceed anyway...
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        )
    }
}